export default "/view/img/484ca5d09ea539dfdb2329fe7f5a1d46.png";